import { render } from "./CalendarRouterView.vue?vue&type=template&id=40ab516c"
const script = {}
script.render = render

export default script